(() => {
  const target = document.querySelector('[data-bp-redirect]')?.dataset.bpRedirect;
  if (target && !window.Shopify?.designMode) window.location.replace(target);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.bp-mobile-menu[open]');
      if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    }
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.bp-mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
})();
